module.exports = __webpack_public_path__ + "officialStatic/img/n2.1c42e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/n2.png
// module id = jFXA
// module chunks = 0